import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useAuth } from '../../contexts/auth';
import api from '../../services/api';
import TagForm, { TagFormFields } from '../../components/Tag/TagForm';

export default function TagsEdit() {
  const {
    user: { organization },
  } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [formFields, setFormFields] = useState<TagFormFields>(
    null as unknown as TagFormFields
  );
  const [formErrors, setFormErrors] = useState({});

  async function getTag() {
    try {
      if (organization && id) {
        const { data } = await api.get(
          `organizations/${organization.id}/tags/${id}`
        );

        setFormFields({
          name: data.name,
          color: `#${data.color}`,
        });
        setIsLoading(false);
      }
    } catch (e) {
      console.log(e);
    }
  }

  const onSubmit = async (data: TagFormFields) => {
    try {
      const { color, ...rest } = data;
      await api.put(`organizations/${organization.id}/tags/${id}`, {
        color: color?.replace('#', ''),
        ...rest,
      });

      navigate('/tags');
    } catch (e: any) {
      if (e.response.data.errors) {
        setFormErrors(e.response.data.errors);
      }
    }
  };

  useEffect(() => {
    getTag();
  }, [organization, id]);

  return (
    <TagForm
      isLoading={isLoading}
      title='Editar Etiqueta'
      formFields={formFields}
      formErrors={formErrors}
      onSubmit={onSubmit}
    />
  );
}
